import { CSSProperties, ReactElement, ReactNode, useEffect } from 'react';
import { FormProps, FormInstance } from 'antd';
import { Form } from 'common/components/antd/Form/Form';
import { KEY_SEPARATOR } from '../../table.constants';
import { TScopeRecord, TTableColumn } from '../../table.types';

const mapPermissionInitialValues = (columns: TTableColumn[], rows: TScopeRecord[]): any => {
  let initialValues = {};

  if (!columns) {
    return initialValues;
  }

  for (let i = 0; i < columns.length; i += 1) {
    const column = columns[i];

    for (let z = 0; z < rows.length; z += 1) {
      const scopeRow = rows[z];
      const key = [column.key, scopeRow.key].join(KEY_SEPARATOR);
      const isScopeEnabled = scopeRow.children.every((permission) => permission.roles[column.key]);
      initialValues = {
        ...initialValues,
        [key]: isScopeEnabled,
      };
    }

    const permissions = rows.flatMap((scopeRow) => scopeRow.children);

    for (let j = 0, l = permissions.length; j < l; j += 1) {
      const permission = permissions[j];
      const isPermissionEnabled = !!permission.roles[column.key];
      const key = [column.key, permission.scopeKey, permission.key].join(KEY_SEPARATOR);
      initialValues = {
        ...initialValues,
        [key]: isPermissionEnabled,
      };
    }
  }
  return initialValues;
};

export const PermissionFormComponent = ({
  children,
  style,
  form,
  rows,
  columns,
  onValuesChange,
}: {
  children: ReactNode;
  style?: CSSProperties;
  form: FormInstance;
  rows: TScopeRecord[];
  columns: TTableColumn[];
  onValuesChange: FormProps['onValuesChange'];
}): ReactElement => {
  useEffect(() => {
    // toggle on/off 'scope' checkboxes after searching
    form.resetFields();
  }, [rows]);

  const formInitialValues = mapPermissionInitialValues(columns, rows);

  return (
    <Form form={form} initialValues={formInitialValues} onValuesChange={onValuesChange} style={style}>
      {children}
    </Form>
  );
};
